import { Link, useLocation } from 'react-router-dom';

function ClientBottomNav() {
  const location = useLocation();

  const navItems = [
    { path: '/', icon: 'home', label: 'Início' },
    { path: '/catalogo', icon: 'th-large', label: 'Catálogo' },
    { path: '/promocoes', icon: 'tag', label: 'Ofertas' },
    { path: '/carrinho', icon: 'shopping-bag', label: 'Carrinho' },
    { path: '/perfil', icon: 'user', label: 'Perfil' },
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname === '/home';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
        >
          <i className={`fas fa-${item.icon}`}></i>
          <span>{item.label}</span>
        </Link>
      ))}
    </nav>
  );
}

export default ClientBottomNav;

